import FlagIN from "../assets/flags/india.png";
import FlagKSA from "../assets/flags/saudiarabia.png";
import FlagBD from "../assets/flags/bangladesh.png";
const flags = {
  IN: FlagIN,
  BD: FlagBD,
  KSA: FlagKSA,
};

export const getFormattedDate = (dateString, type = "mm") => {
  // Define the mapping for month abbreviations
  const monthAbbreviations = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  // Check if the input date string matches the 'dd-mmm-yyyy' format

  const mmmFormatRegex = /^(\d{2})-(\w{3})-(\d{4})$/;
  const mmmMatch = dateString?.match(mmmFormatRegex);

  if (mmmMatch && type == "mm") {
    const day = mmmMatch[1];
    const monthAbbr = mmmMatch[2];
    const year = mmmMatch[3];

    // Convert the month abbreviation to the numeric month
    const month = monthAbbreviations[monthAbbr];

    // Create the 'dd-mm-yyyy' formatted date
    const convertedDate = `${day}-${month}-${year}`;

    return convertedDate;
  }

  // Check if the input date string matches the 'dd-mm-yyyy' format
  const mmFormatRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
  const mmMatch = dateString?.match(mmFormatRegex);

  if (mmMatch && type == "mmm") {
    const day = mmMatch[1];
    const month = mmMatch[2];
    const year = mmMatch[3];

    // Convert the numeric month to the month abbreviation
    const monthAbbr = Object.keys(monthAbbreviations).find(
      (key) => monthAbbreviations[key] === month
    );

    // Create the 'dd-mmm-yyyy' formatted date
    const convertedDate = `${day}-${monthAbbr}-${year}`;

    return convertedDate;
  }

  // If the input date format doesn't match either pattern, return an error message
  return dateString;
};

export const getFlag = (country_code = "IN") => {
  const flag = flags[country_code];
  return flag;
};

export const printValidationError = (err, component) => {
  if (err?.response?.status === 401) {
    const validationError = err.response?.data?.validation_error;
    // console.log(validationError);
    if (validationError) {
      for (let col in validationError) {
        const element = document.getElementById(`${component}-${col}`);
        // console.log(component, col);
        if (element) {
          element.style.display = "flex";
          element.innerText = validationError[col].toString();
        }
      }
    }
  }
};

export const sliceWords = (sentence, count) => {
  const updated = sentence?.split(" ").slice(0, 20).join(" ");
  const dot = sentence.split(" ").length > 20 ? "..." : "";
  return updated + dot;
};

export const getObjectValue = (obj, key) => {
  const keys = String(key).split(".");
  return keys.reduce((obj, level) => obj && obj[level], obj);
};

export const splitWord = (inputString, letterCount = 6) => {
  if (String(inputString).length < 6) {
    return inputString;
  }

  let result = [];
  for (let i = 0; i < String(inputString).length; i += letterCount) {
    result.push(String(inputString).substr(i, letterCount));
  }

  return result.join("\n");
};

export function flattenObjectsInArray(arr, keysToExclude = []) {
  const flattenedArray = [];

  arr.forEach((obj) => {
    const result = {};

    function flattenObject(obj, parentKey = "") {
      for (let key in obj) {
        if (obj.hasOwnProperty(key) && !keysToExclude.includes(key)) {
          let newKey = parentKey ? `${parentKey}_${key}` : key;

          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[newKey] = obj[key];
            flattenObject(obj[key], newKey);
          } else {
            result[newKey] = obj[key];
          }
        } else {
          result[key] = obj[key];
        }
      }
    }

    flattenObject(obj);
    flattenedArray.push(result);
  });

  return flattenedArray;
}
